import { Typography } from "@mui/material";
import { FC, Fragment } from "react";
import { GradientCircularProgress } from "@/components/pages/infrastructure-architecture/components/GradientCircularProgress";

export const InfrastructureArchitectureDiagramLoading: FC = () => {
  return (
    <Fragment>
      <GradientCircularProgress />

      <Typography variant="h6" fontWeight="normal">
        This may take a moment...
      </Typography>
    </Fragment>
  );
};
